require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-interior-design-toorak-garden-residence.json") })
        }
      }, "path---journal-interior-design-toorak-garden-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-interior-design-toorak-garden-residence!./.cache/json/journal-interior-design-toorak-garden-residence.json
// module id = 503
// module chunks = 231608221292675